module.exports = __webpack_public_path__ + "static/media/jump-page-mobile.3ce3e018.png";